﻿import { createFileRoute } from "@tanstack/react-router";
import { ConfigPage } from "@/paginas/pg_preferencias/preferencias-main";

export const Route = createFileRoute("/_authenticated/preferencias")({
  head: () => ({
    meta: [
      { title: "Configurações — Milky Moo Palmares" },
      {
        name: "description",
        content: "Preferências de exibição do sistema de estoque da sorveteria.",
      },
      { property: "og:title", content: "Configurações — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Preferências de exibição do sistema de estoque da sorveteria.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ConfigPage,
});
